import React from 'react'
import Navbar from '../Navbar';
import Footer from '../Footer';
import { Link } from 'react-router-dom';
import DotRing from '../../component/dot/DotRing';
import investerBanner from '../../assests/investor relationship/handshake.webp';
import '../../hamcss/investor.css';
import { useState } from 'react'
import { FaRegFilePdf } from "react-icons/fa";
import { FaFileVideo } from "react-icons/fa";
import dn from '../../assests/sgPdf/debeture/Debeture Trustee Details.pdf';
import dc from '../../assests/sgPdf/debeture/Disclsoure_Clause-9_March 2025.pdf';
import dcn from '../../assests/sgPdf/debeture/Disclosure_NCD_Chapter-XIV-March 2025.pdf';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
const NonConvertible = () => {

    return (
        <>

            <DotRing />

            <Navbar />
            <section>
                <div className="BreadArea" style={{
                    backgroundImage: `url(${investerBanner})`,
                }}>
                    <div className="container">
                        <h2>Non-Convertible Debt Securities</h2>
                    </div>
                </div>
            </section>


            <div className='main_investor_containner'>
                <h3 style={{ textAlign: 'center' }}>Non-Convertible Debt Securities</h3>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '840px' }}>

                        <div className='investor_row_data'>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <span>a. </span>
                                <p className='text_data_investor' style={{ margin: '0' }}> 	Name of the Debenture Trustees with full contact details </p>
                            </div>
                            <a href={dn}> <button className='investor_button'> click here </button></a>
                        </div>
                        <div className='investor_row_data'>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <span>b. </span>
                                <p className='text_data_investor' style={{ margin: '0' }}>  The information, report, notices, call letters, circulars, proceedings, etc concerning Non-Convertible Redeemable Preference Shares or Non-Convertible Debt Securities </p>
                            </div>
                            <a href={dcn}>  <button className='investor_button'> click here </button></a>
                        </div>
                        

                        

                        <div className='investor_row_data-fina'>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <span>c. </span>
                                <p className='text_data_investor' style={{ margin: '0' }}> 	All information and reports including compliance reports filed by the listed entity</p>
                            </div>

                            <ul style={{ marginTop: '20px', justifyContent: 'space-between' }}>
                                <li>Default by issuer to pay interest or redemption amount
                                <a style={{float:"right"}}>  <button className='investor_button'>NA</button></a></li>
                                <br />
                                <li>Failure to create a charge on the assets
                                <a style={{float:"right"}}>  <button className='investor_button'>NA</button></a></li>
                            </ul>


                        </div>


                        
                        



                    </div>
                </div>
            </div >

        
            


            <Footer />
        </>
    )
}

export default NonConvertible